import React, { memo } from 'react';
import { Box } from '@mui/material';

const SubTitleExceptions = () => {
  return (
    <Box component={'span'}
         sx={{
           fontWeight: 500,
           fontStyle: 'italic',
           color: 'text.secondary',
         }}>
      Exceptions
    </Box>
  );
};

export default memo(SubTitleExceptions);
